import { render } from "./ShapeGathering.vue?vue&type=template&id=db52996a&scoped=true"
import script from "./ShapeGathering.vue?vue&type=script&lang=js"
export * from "./ShapeGathering.vue?vue&type=script&lang=js"

import "./ShapeGathering.vue?vue&type=style&index=0&id=db52996a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db52996a"]])

export default __exports__